import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import {
	createOnboardingScore,
	PostOnboardingScoringResponse
} from '@/services/onboardingLeadScore';

export const useCreateOnboardingScore = (): UseMutationResult<
	HttpResponseSuccess<PostOnboardingScoringResponse>,
	Error
> => {
	return useMutation({
		mutationFn: createOnboardingScore,
		onError: error => {
			throw new Error('Error creating user onboarding:', error);
		}
	});
};
